import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    values: {},
    breadcrumbs: [],
    status: "idle",
    error: null,
};

const dynamicStateSlice = createSlice({
    name: "genericIds",
    initialState: {
        ...initialState,
        values: {},
    },
    reducers: {
        addValue(state, action) {
            const { key, value } = action.payload;
            state.values[key] = { ...value };
        },
        updateValue(state, action) {
            const { key, value } = action.payload;
            if (state.values[key]) {
                state.values[key] = { ...state.values[key], ...value };
            }
        },
        removeValue(state, action) {
            const { key } = action.payload;
            delete state.values[key];
        },
        resetValues(state) {
            state.values = {};
        },

    }
});

export const { addValue, updateValue, removeValue, resetValues } = dynamicStateSlice.actions;
export default dynamicStateSlice.reducer;
